import React from "react";
import { CaretDownIcon } from "@phosphor-icons/react";
import "./CustomSelect.css";

const CustomSelect = ({ value, onChange, options = [], className = "" }) => {
  return (
    <div className={`custom-select-wrapper ${className}`}>
      <select
        value={value}
        onChange={onChange}
        className="form-select form-select-sm custom-select"
        style={{ textAlign: "left", textAlignLast: "left" }}
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            style={{ textAlign: "left" }}
          >
            {option.label}
          </option>
        ))}
      </select>

      <CaretDownIcon size={16} className="custom-select-icon" />
    </div>
  );
};

export default CustomSelect;
